import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import "reflect-metadata";

// interface and class 1
export interface IExampleService {
  getExample(): Promise<string>;
}

@injectable()
export class ExampleService implements IExampleService {
  getExample(): Promise<string> {
    return Promise.resolve("Hello World");
  }
}

// interface and class 2
export interface IExampleService2 {
  method(): Promise<string>;
}

@injectable()
export class ExampleService2 implements IExampleService2 {
  @inject(SERVICE_TYPES.ExampleService) exampleService!: IExampleService;

  method(): Promise<string> {
    return this.exampleService.getExample();
  }
}
